export class UserProfile {
    email: string = ""
    firstName: string = ""
    lastName: string = ""
    userRole: string = ""
    zipCode: string = ""
    /*
    Represents the ID of the school stored in the database.
    The exception is the value -1 which signals that the school is a suggested one
     */
    userSchool: number | null = null
    gradeRange: string[] = []
    hasPBSAccount: boolean = false
    preferredSubjects: string[] = []

    constructor(response) {
        this.email = response.user.email
        this.firstName = response.user.first_name
        this.lastName = response.user.last_name
        this.userRole = response.user_role
        this.zipCode = response.postal_code
        this.userSchool = response.school
        this.gradeRange = response.grade_range
        this.preferredSubjects = response.preferred_subjects
        this.hasPBSAccount = response.has_pbs_account
    }

    public reverseToApiResponse() {
        return {
            grade_range: this.gradeRange,
            postal_code: this.zipCode,
            preferred_subjects: this.preferredSubjects,
            school: this.userSchool,
            user: {
                email: this.email,
                first_name: this.firstName,
                last_name: this.lastName,
            },
            user_role: this.userRole,
        }
    }
}
